import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import propTypes from 'prop-types';
import Checkbox from '@mui/material/Checkbox';
import { StyledButton } from '../../../Components/Generics.styled';
import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';

const AdServicesProductsContainer = styled.div`
    height: 100%;
    width: 100%;
    max-width: 100%;
    display: flex;
    flex-direction: column;
`;
const Title = styled.div`
    margin-top: 50px;
    font-size: 23px;
    font-weight: bold;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
    height: 50px;
    flex-direction: column;
    text-align: center;
`;

const ProductsSection = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    place-items: center; /* Center items both horizontally and vertically */
    gap: 30px;
    width: 100%;
    height: 100%;
`;

const FilterButtons = styled(Button)`
    font-size: 12px !important;
    background-color: ${(props) => (props.selected ? '#ff8560' : '#2e69fe')} !important;
`;

const LearnMoreBtn = styled(StyledButton)`
    margin-top: 8px;
    margin-bottom: 8px;
    font-size: 14px;
`;

const GridItem = styled.div`
    padding: 10px; /* Add padding as needed */
    text-align: center; /* Center the text within each item */
`;
const StyledProductContainer = styled.div`
    background-color: #fafbf7;
    display: flex;
    flex-direction: column;
    border: 1px solid black;
    border-radius: 25px;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.5);
    height: 20vw; /* Use viewport units for height */
    width: 20vw; /* Use viewport units for width */
    max-height: 300px; /* Set a maximum height if needed */
    max-width: 300px; /* Set a maximum width if needed */
    min-height: 150px; /* Set a minimum height if needed */
    min-width: 150px; /* Set a minimum width if needed */
    align-items: center;
    justify-content: center;
`;

const StyledImgContainer = styled.div`
    height: 60%; /* Adjust the percentage based on your design */
    width: 60%; /* Adjust the percentage based on your design */
    position: relative; /* Add position relative to handle absolute positioning of the button */
`;
const StyledImg = styled.img`
    height: 100%;
    width: 100%;
    object-fit: contain;
`;

const StyledProductName = styled.div`
    font-weight: bold;
`;
const StyledProductPrice = styled.div``;

const FiltersContainer = styled.div`
    display: flex;
    justify-content: right;
    margin-bottom: 30px;
`;

const AllProductsContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;
const MyOfferingsContainer = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const Header = styled.div`
    font-size: 18px;
    font-weight: bold;
    padding: 16px;
`;

const AdServicesProducts = ({ filterByCategory, selectedCategory, history, allAdServicesByCategory, setSelectedService, myServicesData }) => {
    // Function to toggle the checked state of an item

    const proceedToDetails = (item) => {
        setSelectedService(item);
        history.push('/portal/adServices/details');
    };

    const StyledProduct = ({ productName, productImgSrc, onClick }) => {
        return (
            <StyledProductContainer>
                <StyledImgContainer>
                    <StyledImg src={productImgSrc} alt={productName} loading="lazy" />
                </StyledImgContainer>
                <StyledProductName>{productName}</StyledProductName>

                <LearnMoreBtn onClick={onClick}>Learn More</LearnMoreBtn>
            </StyledProductContainer>
        );
    };

    StyledProduct.propTypes = {
        productName: propTypes.string,
        productImgSrc: propTypes.string,
        onClick: propTypes.func,
    };

    return (
        <AdServicesProductsContainer>
            <Title>Ad Services</Title>
            <MyOfferingsContainer>
                <Header>My Custom Services</Header>
                <ProductsSection numOfItems={myServicesData?.length}>
                    {myServicesData?.length > 0 &&
                        myServicesData?.map((item, idx) => {
                            return (
                                <GridItem key={idx + 1}>
                                    <StyledProduct
                                        productName={item.adServiceTitle || ''}
                                        productImgSrc={item.azureFileURL || ''}
                                        onClick={() => proceedToDetails(item)}
                                    />
                                </GridItem>
                            );
                        })}
                </ProductsSection>
            </MyOfferingsContainer>

            <AllProductsContainer>
                <Header>All Services</Header>
                <FiltersContainer>
                    <ButtonGroup variant="contained" aria-label="outlined primary button group">
                        {allAdServicesByCategory?.map((item, idx) => {
                            return (
                                <FilterButtons
                                    selected={selectedCategory.adServiceCategoryId === item.adServiceCategoryId}
                                    key={idx + 1}
                                    variant="contained"
                                    color="primary"
                                    onClick={() => filterByCategory(idx)}
                                >
                                    {item.adServiceCategoryName}
                                </FilterButtons>
                            );
                        })}
                    </ButtonGroup>
                </FiltersContainer>

                <ProductsSection numOfItems={selectedCategory?.adServices?.length}>
                    {selectedCategory?.adServices?.length > 0 &&
                        selectedCategory?.adServices.map((item, idx) => {
                            return (
                                <GridItem key={idx + 1}>
                                    <StyledProduct
                                        key={idx}
                                        productName={item.adServiceTitle || ''}
                                        productId={item.adServiceId || ''}
                                        productPrice={item.price || 0}
                                        productImgSrc={item.azureFileURL || ''}
                                        onClick={() => proceedToDetails(item)}
                                        productKey={idx}
                                    />
                                </GridItem>
                            );
                        })}
                </ProductsSection>
            </AllProductsContainer>
        </AdServicesProductsContainer>
    );
};

AdServicesProducts.propTypes = {
    selectedCategory: propTypes.shape({
        adServiceCategoryId: propTypes.number,
        adServices: propTypes.array,
    }),
    history: propTypes.shape({ push: propTypes.func }),
    allAdServicesByCategory: propTypes.array,
    filterByCategory: propTypes.func,
    selectedService: propTypes.shape({}),
    setSelectedService: propTypes.func,
    myServicesData: propTypes.array,
};

AdServicesProducts.defaultProps = {
    selectedCategory: {},
    setSelectedCategory: () => {},
    productData: [],
    history: [],
};

export default AdServicesProducts;
